module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/about-olivia-662.e4edfd1b4c85920a.jpg"+" 662w",
        images: [{path: "https://static.sniffspot.com/packs/img/about-olivia-662.e4edfd1b4c85920a.jpg",width: 662,height: 649}],
        src: "https://static.sniffspot.com/packs/img/about-olivia-662.e4edfd1b4c85920a.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/about-olivia-662.e4edfd1b4c85920a.jpg"},
        
        width: 662,
        height: 649
      }